module.exports = __webpack_public_path__ + "img/1F644.eeb8e478.svg";